export const BROWSERS = {
  CHROME: 'chrome',
  EDGE: 'edge',
  FIREFOX: 'firefox',
  INTERNET_EXPLORER: 'ie',
  IPAD_CHROME: 'crios',
  OPERA: 'opera',
  SAFARI: 'safari',
}
